import type { Medication } from '../types';

/**
 * `medications` tem dois formatos no sistema: o formulário trabalha com lista,
 * mas a API persiste e devolve um texto único ("Nome Dose Horário | ...").
 *
 * Tratar só um dos formatos quebrava a exportação em PDF/Excel de qualquer
 * paciente carregado da API (`.forEach is not a function`).
 */
export function medicationList(
  medications?: Medication[] | string | null,
): { name: string; quantity: string; time: string }[] {
  if (Array.isArray(medications)) {
    return medications.map((m) => ({
      name: m?.name ?? '',
      quantity: m?.quantity ?? '',
      time: m?.time ?? '',
    }));
  }

  if (typeof medications !== 'string' || !medications.trim()) return [];

  return medications
    .split('|')
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => ({ name: item, quantity: '', time: '' }));
}

/** Texto para exibição, independente do formato de origem. */
export function medicationsToText(medications?: Medication[] | string | null): string {
  const list = medicationList(medications);
  if (!list.length) return '';
  return list
    .map((m) => [m.name, m.quantity, m.time].filter(Boolean).join(' '))
    .join(' | ');
}
